module.exports = __webpack_public_path__ + "img/flow-step-4.8893f5b.png";